import ApiManager from '../../utils/ApiManager'
import Constants from '../../utils/Constants'
import StringFormat from '../../utils/StringFormat'
import moment from 'moment-ja'
import _ from 'lodash'

const initialUser = () => {
  return {
    id: null,
    role: 1,
    userId: '',
    contractId: null,
    departmentId: null,
    password: '',
    userName: '',
    email: null,
    memberIdFlag: 2,
    discountFlag: 1,
    grossFlag: 1,
    cardFlag: 1,
    paymentFlag: 1,
    stopFlag: '1',
    registerMailSendFlag: 0,
    registerMailSendDatetime: moment().format('YYYY-MM-DD 00:00'),
    activeFrom: '',
    product_flag: 1,
    member_attribute_flag: 1,
    member_address_flag: 1,
    gross_flag: 1,
    activeTo: '',
    receipt_masking_flag: 1,
    store_analysis_flag: null
  }
}

const state = {
  user: initialUser(),
  departmentList: [],
  message: {
    content: '',
    type: ''
  },
  redirectToLogin: false
}

const actions = {

  async detail ({ dispatch, state, commit }, id) {
    this.dispatch('loading/loadingPagePlus')
    commit('init')
    let type = 'success'
    const response = await ApiManager.request('User').userDetail(id)
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
      commit('setUser', response.data.data)
    } else if (response.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
      type = 'error'
    }
    commit('setMessage', { content: response.data.data.message, type: type })
    this.dispatch('loading/loadingPageMinus')
  },

  async getDepartmentList ({ state, commit }, contractId) {
    const response = await ApiManager.request('Department').departmentList(contractId)
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
      commit('setDepartmentList', response.data.data)
    }
  },

  /**
   * 自分自身の情報の更新処理を行う
   */
  async updateUser ({ state, commit }, user) {
    this.dispatch('loading/loadingPagePlus')
    let response = null
    if (user.id) {
      response = await ApiManager.request('User').userEdit(user)
    } else {
      response = await ApiManager.request('User').userAdd(user)
    }
    let type = 'success'
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
      commit('setRedirectToLogin', response.data.meta.redirect_to_login)
    } else if (response.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
      type = 'error'
    }
    commit('setMessage', { content: response.data.data.message, type: type })
    this.dispatch('loading/loadingPageMinus')
  }

}

const mutations = {
  init (state, data) {
    state.message = {
      content: '',
      type: ''
    }
  },
  setMessage (state, data) {
    state.message = data
  },
  setUser (state, data) {
    state.user.id = data.id
    state.user.role = data.role
    state.user.userId = data.user_id
    state.user.contractId = data.contract_id
    state.user.departmentId = data.department_id
    state.user.userName = data.user_name
    state.user.email = data.email
    state.user.memberIdFlag = data.member_id_flag
    state.user.discountFlag = data.discount_flag
    state.user.grossFlag = data.gross_flag
    state.user.cardFlag = data.card_flag
    state.user.paymentFlag = data.payment_flag
    state.user.product_flag = data.product_flag
    state.user.member_attribute_flag = data.member_attribute_flag
    state.user.member_address_flag = data.member_address_flag
    state.user.gross_flag = data.gross_flag
    state.user.stopFlag = data.stop_flag + '' || '1'
    state.user.registerMailSendFlag = data.register_mail_send_flag
    if (data.register_mail_send_flag === 0) {
      state.user.registerMailSendDatetime = StringFormat.ymdhmFormat(data.register_mail_send_datetime)
    }
    state.user.activeFrom = StringFormat.ymdFormatUTC(data.active_from)
    state.user.activeTo = StringFormat.ymdFormatUTC(data.active_to)
    state.user.receipt_masking_flag = data.receipt_masking_flag
    state.user.store_analysis_flag = data.store_analysis_flag
    state.user.mfa_enabled = data.mfa_enabled
  },
  resetUser (state, data) {
    const user = initialUser()
    _.each(user, (value, key) => {
      state.user[key] = value
    })
  },
  setDepartmentList (state, data) {
    state.departmentList = data
  },
  setRedirectToLogin (state, redirectToLogin) {
    state.redirectToLogin = redirectToLogin
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
